import React from 'react';

import Box from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography';

import { FormattedMessage } from '@futrli/localisation';

import { CreateReportingPopover } from './components/create-reporting-popover/create-reporting-popover';
import { ReportingTabs } from './components/tabs/reporting-tabs';

export const ReportsContainer = () => {
  return (
    <Box margin="auto" padding="32px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h1" fontSize="24px" fontWeight="700" mb={0}>
          <FormattedMessage id="reporting.reports" defaultMessage="Reports" />
        </Typography>
        <CreateReportingPopover />
      </Box>
      <ReportingTabs />
    </Box>
  );
};
